// extracted by mini-css-extract-plugin
module.exports = {"clickableTag":"styles_clickableTag__2HdVo"};